<template>
  <div>
    <confirmation-popup title="Filters" id="available-filters-popup" confirm-btn-text="Filter" :showCancelBtn="false"
                        @on-confirm="submitForm">
      <form class="form-horizontal" autocomplete="off" id="available_fltr_form" method="GET" action="">
        <div class="form-group">
          <label class="col-md-3 control-label" style="margin-bottom: 10px;">Keywords</label>
          <div class="col-md-9" >
            <input type="text" ref="keywords" class="form-control text-modal" name="fltr[keywords]" placeholder="Search by name or display name" v-model="filters.keywords">
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-3 control-label">Service</label>
          <div class="col-md-9" >
            <select ref="active_service_ids" id="services_holder" name="fltr[active_service_ids][]" class="select2 form-control" multiple data-placeholder="Select services"
                    v-model="filters.active_service_ids">
              <option v-for="active_service in active_services" :value="active_service.service_id">{{ active_service.service_name }}</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-3 control-label">Service Attributes</label>
          <div class="col-md-9" >
            <select ref="service_attributes" name="fltr[service_attributes][]" class="select2 form-control" multiple
                    data-placeholder="Select services" v-model="filters.service_attributes">
              <option v-for="service_attribute in all_service_attributes" :value="service_attribute.value">{{ service_attribute.text }}</option>
            </select>
          </div>
        </div>
        <div class="form-group contractor-status" >
          <label class="col-md-3 control-label">Status</label>
          <div class="col-md-9" >
            <select name="fltr[active]" ref="active" class="select2 form-control" :data-placeholder="`Select ${available_data?available_data.labelWorkersNameSingular:''} status`"
            v-model="filters.active">
              <option value="TRUE">Active</option>
              <option value="FALSE">Inactive</option>
              <option value="ALL">All</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-3 control-label">Label</label>
          <div class="col-md-9">
            <select ref="label_ids" name="fltr[label_ids][]" class="select2 form-control"
                    multiple data-placeholder="Select labels" v-model="filters.label_ids">
              <option v-for="label in allLabels" :value="label.id">{{ label.label_name }}</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label for="filter_by_radius" class="col-md-3 col-xs-9 control-label">Filter by radius</label>
          <input type="hidden" name="filter_by_radius" value="0"/>
          <div class="material-switch col-md-9 col-xs-3 position-relative top-8 mobile-top-0">
            <input class="checkbox-type-settings switch-checkbox" ref="filter_by_radius" name="fltr['filter_by_radius']" v-model="filters.filter_by_radius" value="1" id="filter_by_radius" type="checkbox" >
            <label class="label-default" for="filter_by_radius"></label>
          </div>
        </div>
        <div class="form-group" v-show="filters.filter_by_radius">
          <label class="col-md-3 control-label">Radius</label>
          <div class="col-md-9">
            <div class="input-group  bs-form tf-form no-padding-left no-padding-custom-mobile pair-of-input">
              <span class="input-group-addon " style="font-size: large;" id="basic-addon1">{{ available_data?available_data.unit:'' }}</span>
              <input type="text" ref="radius" name="fltr['radius']" v-model="filters.radius" class="form-control decimal_filter">
            </div>
            <span class="help-block">Note: Setting the radius to 0 will filter results based on a specific point.</span>
          </div>
        </div>

        <div class="form-group">
          <label for="check_real_time_availability" class="col-md-3 col-xs-9 control-label">Real time availability</label>
          <input type="hidden" name="check_real_time_availability" value="0"/>
          <div class="material-switch col-md-9 col-xs-3 position-relative top-8 mobile-top-0">
            <input class="checkbox-type-settings switch-checkbox" ref="check_real_time_availability" name="fltr['check_real_time_availability']"  v-model="filters.check_real_time_availability" value="1" id="check_real_time_availability" type="checkbox">
            <label class="label-default" for="check_real_time_availability"></label>
          </div>
        </div>

      </form>
    </confirmation-popup>
  </div>
</template>
<script>
export default {
  name: "AvailableFieldworkersFilters",
  components: {},
  props: {
    value: {
      type: Object,
    },
    available_data: {
      type: Object
    },
    all_service_attributes: {
      type: Array
    },
    active_services: {
      type: Array
    },
    allLabels:{
      type: Array
    }
  },
  data(){
    return {
      filters:  this.value,
    }
  },
  methods:{
    submitForm(){
      $("#available-filters-popup").modal("hide");
      this.fillFltrButton();
      this.$emit('submit-available')
    },
    fillFltrButton(){
      let tags = []
      for(const key in this.filters){
        if(this.filters[key]){
          let input = $(this.$refs[key])
          let tag1 = ""
          if(input.is("input"))
            tag1 = input.val()
          else if(input.hasClass("select2")){
            if($.isArray(this.filters[key])){
              let dataobj = input.select2('data')
              for (var i = 0; i < dataobj.length; i++) {
                tag1 = dataobj[i].text;
              }
            }else
              tag1 = input.find('option:selected').text()
          }
          if(tag1)
            tags.push(tag1)

        }
      }
      if(tags.length>0){
        let tagsText = tags.slice(0,2).join(",")
        if(tags.length>2){
          tagsText += " and more";
        }
        if (screen.width > 991 && screen.width < 1230) {
          tagsText = tagsText.slice(0,35);
          tagsText += '...'
        }
        var fltrBtn = $(".filters-icon-btn");
        fltrBtn.addClass("filters-tags");
        fltrBtn.html('<i class="fa fa-sliders"></i><span class="filters-span">'+" Filters: "+tagsText+ '</span>');
      }
    }
  },
  mounted() {
    $(".select2").select2();
    $(this.$refs.label_ids).on('change', (event) => {
      this.filters.label_ids =  $(this.$refs.label_ids).val()??[];
    });
    $(this.$refs.active_service_ids).on('change', (event) => {
      this.filters.active_service_ids =  $(this.$refs.active_service_ids).val()??[];
    });
    $(this.$refs.service_attributes).on('change', (event) => {
      this.filters.service_attributes =  $(this.$refs.service_attributes).val()??[];
    });
  },
  watch: {
    filters: {
      handler(filtersValue) {
        this.$emit('input', filtersValue)
        this.$nextTick(function(){

        })
      },
      deep: true
    },
    value: {
      handler(filtersValue) {
        this.filters = filtersValue
      }
    }
  }
}
</script>
<style scoped>
@media (max-width: 991px) {
  .mobile-top-0{
    top: 0px;
  }
}
</style>